import { ReactElement } from "react";

interface ButtonProps {
  text: string;
  onClick?: () => void;
  className?: string;
  icon?: ReactElement;
  type?: "button" | "submit" | "reset";
  disabled?: boolean;
  ariaLabel?: string;
}

const Button = ({ text, className, onClick, icon, type, disabled, ariaLabel }: ButtonProps) => (
  <button 
    className={`recoEngine__button ${className}`} 
    onClick={onClick} 
    type={type}
    disabled={disabled}
    aria-label={ariaLabel}
  >
    {icon}
    <p className="button_text">{text}</p>
  </button>
);

export default Button;
